import { Card, CardContent, Typography } from '@mui/material'
import type { SimulationInput, SimulationResults } from '../../api/types'
import { formatEUR2 } from '../../format'
import ComputedField from './ComputedField'
import FieldsGrid from './FieldsGrid'
import { rentabiliteReventeFields, type FieldKey } from './formFields'

export default function RentabiliteReventeCard({
  form,
  preview,
  setNum,
}: {
  form: SimulationInput
  preview: SimulationResults
  setNum: (key: FieldKey, raw: string) => void
}) {
  return (
    <Card>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Rentabilité achat/revente
        </Typography>
        <FieldsGrid fields={rentabiliteReventeFields} form={form} setNum={setNum}>
          <ComputedField
            label="Impôt sur la plus-value"
            value={formatEUR2(preview.capitalGainsTaxAmount)}
            tone={preview.grossMargin <= 0 ? 'negative' : 'default'}
            hint={
              preview.grossMargin <= 0
                ? "Pas de plus-value taxable : l'estimation de revente ne couvre pas le coût de l'investissement."
                : undefined
            }
          />
          <ComputedField
            label="Pénalités bancaires (IRA) "
            value={formatEUR2(preview.earlyRepaymentIra)}
            hint="Indemnité de remboursement anticipé suggérée : plafond légal de 6 mois d'intérêts ou 3% du capital restant dû, selon le plus faible."
          />
          <ComputedField
            label="Intérêts pendant la détention"
            value={formatEUR2(preview.interestDuringHolding)}
            hint="Intérêts du prêt payés pendant la durée de détention, jusqu'au remboursement anticipé."
          />
        </FieldsGrid>
      </CardContent>
    </Card>
  )
}
